// Schema for Venue vendor-type-specific fields.

import {
  VENUE_TYPES, EVENT_HOURS, VENUE_AMENITIES, AVAILABILITY_OPTIONS,
  SERVICE_STYLES, DIETARY_OPTIONS, BAR_STYLES, BAR_SERVICE_OPTIONS,
} from '../constants/vendorOptions';
import { rentalItemsGroupFields } from './fragments/rentalItemsGroup';

export const venueSchema = {
  vendorType: 'Venue',
  fields: [
    { key: 'venueTypes', type: 'chips', label: 'Venue Types *', displayLabel: 'Venue Type', options: VENUE_TYPES },
    { key: 'venueHasPermitting', type: 'checkbox', label: 'We have the necessary permitting to operate as a venue' },
    { key: 'readySuitesAvailable', type: 'checkbox', label: 'Ready suites available' },
    {
      key: 'eventCoordinationIncluded',
      type: 'checkbox',
      label: 'In-House Event Coordination/Planning Available',
      trueLabel: 'Available',
      falseLabel: 'Not Available',
    },
    { key: 'venueGuestCapacity', type: 'number', label: 'Guest Capacity', maxDigits: 4, saveAs: 'int', formatted: true, optional: true },
    { key: 'venueMaxEventsPerDay', type: 'number', label: 'Max Events Per Day', maxDigits: 3, saveAs: 'int', optional: true },
    {
      type: 'row',
      fields: [
        { key: 'venueStartingPrice', type: 'price', label: 'Starting Price', optional: true },
        { key: 'venueAvgPrice', type: 'price', label: 'Average Price', optional: true },
      ],
    },
    {
      type: 'selectRange',
      label: 'Event Hours',
      minKey: 'venueOpenTime',
      maxKey: 'venueCloseTime',
      minOptions: EVENT_HOURS,
      maxOptions: EVENT_HOURS,
      minPlaceholder: 'Opens at',
      maxPlaceholder: 'Closes at',
      optional: true,
    },
    { key: 'venueAmenities', type: 'chips', label: 'Amenities', options: VENUE_AMENITIES, optional: true },
    { key: 'venueCatering', type: 'chips', label: 'Catering', options: AVAILABILITY_OPTIONS, optional: true },
    {
      key: 'cateringInHouseGroup',
      type: 'group',
      style: 'shaded',
      title: 'In-House Catering Details',
      showIf: { field: 'venueCatering', anyContains: 'In-House' },
      fields: [
        { key: 'serviceStyles', type: 'chips', label: 'Service Style', options: SERVICE_STYLES, optional: true },
        { key: 'dietaryOptions', type: 'chips', label: 'Dietary Options', options: DIETARY_OPTIONS, optional: true },
      ],
    },
    { key: 'venueBar', type: 'chips', label: 'Bar Service', options: AVAILABILITY_OPTIONS, optional: true },
    {
      key: 'barInHouseGroup',
      type: 'group',
      style: 'shaded',
      title: 'In-House Bar Details',
      showIf: { field: 'venueBar', anyContains: 'In-House' },
      fields: [
        { key: 'barStyles', type: 'chips', label: 'Bar Styles', options: BAR_STYLES, optional: true },
        { key: 'barServiceOptions', type: 'chips', label: 'Bar Service Options', options: BAR_SERVICE_OPTIONS, optional: true },
      ],
    },
    { key: 'venueRentalsIncluded', type: 'checkbox', label: 'Rentals included' },
    { key: 'venueRentalsAvailable', type: 'checkbox', label: 'Rentals available' },
    ...rentalItemsGroupFields('venueRentalsAvailable'),
  ],
  requiredChips: [
    { key: 'venueTypes', label: 'venue type' },
  ],
  priceValidations: [
    { startingKey: 'venueStartingPrice', avgKey: 'venueAvgPrice' },
  ],
};